module.exports = __webpack_public_path__ + "img/1.cebe76b4.jpg";